import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { E_DisplayMode } from '../enums/displays/display-mode.enum';

/**
 * Servicio que gestiona los elementos en el LocalStorage
 */
@Injectable({
  providedIn: 'root'
})
export class DisplayModeService {

  private displayMode: BehaviorSubject<E_DisplayMode> = new BehaviorSubject<E_DisplayMode>(E_DisplayMode.Default);

  constructor() { }


  getCurrenDisplayMode(): BehaviorSubject<E_DisplayMode> {
    return this.displayMode;
  }

  setCurrentDisplayMode(mode: E_DisplayMode) {
    this.displayMode.next(mode);
  }


}